// Get base URL from environment or fallback to production
const BASE_URL = process.env.REACT_APP_FRONTEND_URL || 'https://www.depotsecure.net';

export const getSEOData = (page, language = 'fr') => {
  const seoData = {
    home: {
      fr: {
        title: "Accueil - Sécurisez vos dépôts Airbnb",
        description: "DépôtSecure vous aide à sécuriser vos dépôts de garantie Airbnb avec des modèles professionnels, audits express et accompagnement en cas de litige. Conformité légale garantie.",
        keywords: "airbnb, dépôt de garantie, location saisonnière, protection propriétaire, modèles bail, audit express, litige locataire"
      },
      en: {
        title: "Home - Secure your Airbnb deposits",
        description: "DépôtSecure helps you secure your Airbnb security deposits with professional templates, express audits and litigation support. Legal compliance guaranteed.",
        keywords: "airbnb, security deposit, vacation rental, owner protection, lease templates, express audit, tenant dispute"
      }
    },
    services: {
      fr: {
        title: "Nos Services - Modèles, Audits & Accompagnement",
        description: "Découvrez nos 3 offres : Pack Modèles Propriétaire (147€), Audit Express (197€) et Accompagnement Litige (497€). Protection complète pour vos locations Airbnb.",
        keywords: "services airbnb, pack modèles bail, audit état des lieux, accompagnement litige, protection juridique location"
      },
      en: {
        title: "Our Services - Templates, Audits & Support",
        description: "Discover our 3 offers: Owner Template Pack (€147), Express Audit (€197) and Litigation Support (€497). Complete protection for your Airbnb rentals.",
        keywords: "airbnb services, lease template pack, inventory audit, litigation support, legal protection rental"
      }
    },
    blog: {
      fr: {
        title: "Blog - Conseils & Actualités Location Airbnb",
        description: "Nos experts partagent leurs conseils pour gérer vos locations saisonnières, éviter les litiges et maximiser la sécurité de vos dépôts de garantie.",
        keywords: "blog airbnb, conseils location, gestion locative, éviter litiges, dépôt garantie, location saisonnière"
      },
      en: {
        title: "Blog - Airbnb Rental Tips & News",
        description: "Our experts share their tips for managing your vacation rentals, avoiding disputes and maximizing the security of your deposits.",
        keywords: "airbnb blog, rental tips, property management, avoid disputes, security deposit, vacation rental"
      }
    },
    contact: {
      fr: {
        title: "Contact - Nous Contacter",
        description: "Besoin d'aide ou de conseils ? Contactez notre équipe d'experts pour toute question sur la sécurisation de vos dépôts de garantie Airbnb.",
        keywords: "contact depotsecure, aide location airbnb, support propriétaire, conseil juridique location"
      },
      en: {
        title: "Contact - Get in Touch",
        description: "Need help or advice? Contact our team of experts for any questions about securing your Airbnb security deposits.",
        keywords: "contact depotsecure, airbnb rental help, owner support, legal rental advice"
      }
    },
    payment: {
      fr: {
        title: "Paiement - Choisissez votre formule",
        description: "Choisissez la formule qui vous convient et sécurisez vos dépôts de garantie dès aujourd'hui. Paiement sécurisé par Stripe et PayPal.",
        keywords: "paiement depotsecure, achat pack modèles, tarifs services, paiement sécurisé airbnb"
      },
      en: {
        title: "Payment - Choose your plan",
        description: "Choose the plan that suits you and secure your deposits today. Secure payment by Stripe and PayPal.",
        keywords: "depotsecure payment, buy template pack, service prices, secure airbnb payment"
      }
    }
  };

  return seoData[page]?.[language] || seoData.home[language];
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "DépôtSecure",
  "description": "Service d'aide et modèles pour sécuriser vos dépôts de garantie Airbnb",
  "url": BASE_URL,
  "logo": `${BASE_URL}/logo.png`,
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "email": "contact@depotsecure.net",
    "availableLanguage": ["French", "English"]
  },
  "sameAs": [
    "https://www.facebook.com/depotsecure",
    "https://www.linkedin.com/company/depotsecure"
  ]
};

export const getServiceSchema = (serviceName, price, description) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": serviceName,
    "description": description,
    "provider": {
      "@type": "Organization",
      "name": "DépôtSecure"
    },
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": "EUR"
    }
  };
};

export const getBlogPostSchema = (title, description, author, datePublished, image) => {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "author": {
      "@type": "Person",
      "name": author
    },
    "datePublished": datePublished,
    "image": image,
    "publisher": {
      "@type": "Organization",
      "name": "DépôtSecure",
      "logo": {
        "@type": "ImageObject",
        "url": `${BASE_URL}/logo.png`
      }
    }
  };
};
